import { captureException as sentryCaptureException, captureMessage as sentryCaptureMessage } from '@sentry/nextjs';

type ErrorParamsOptions = Record<string, unknown>;

function captureException(error: Error, options?: ErrorParamsOptions): void {
  try {
    sentryCaptureException(error, options);
  } catch (caughtError) {
    console.error('Error in provider ErrorTracking:', caughtError);
  }
}

function captureMessage(message: string, options?: ErrorParamsOptions): void {
  try {
    sentryCaptureMessage(message, options);
  } catch (caughtError) {
    console.error('Error in provider ErrorTracking:', caughtError);
  }
}

export const ErrorTracking = { captureException, captureMessage };
